import { CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle, CFormGroup, CInput, CInputGroup, CInputGroupAppend, CLabel, CSwitch } from '@coreui/react';
import * as React from 'react';
import { ControlTypeEnum, IDispatcher, IImageProvider, IRowDefinition } from '../../abstraction/index';
import { AppLabels } from '../../core/AppLabels';
import { ISizable, Utils } from '../../core/utils';
import { ActionModel, TableModel } from '../../models/index';
import { KControlGraph } from './KControlGraph';
import { KControlTable } from './KControlTable';

interface IProps {
	table: TableModel
	onRowSelected?: (table: TableModel, row: IRowDefinition) => void;
	onActionClicked: (table: TableModel, action: ActionModel, row: any) => void;
	onRowsAdded?: (table: TableModel, rows: any[]) => void;
	hideActionBar?: boolean;
	imageProvider: IImageProvider;
	dispatcher: IDispatcher;
}

interface IState {
	showAsGraph: boolean;
	graphType: string;
}

// Wrapper affichant une tableau ou son équivalent graphique + une barre de controle
// 
export class KControlTableSwitch extends React.Component<IProps, IState> {
	public constructor(props: any) {
		super(props);
		let graphTypes = this.props.table.GraphType;
		

		this.state = {
			showAsGraph: this.props.table.ShowAsGraph,
			graphType: graphTypes  ? this.props.table.GraphType.split(";")[0] : "line",
		}
	}

	//#region local events

	// Sélection d'un élément dans la liste des types de graphiques
	onGraphTypesItemSelected = (x: string) => {
		// Le graphique ne se rafraichit pas lorsque l'on change son type.
		// L'astuce consiste donc à afficher le tableau en changeant showAsGraph, puis, dès que c'est fait
		// à rebasculer sur le graphique (via callback de setstate)
		this.setState({ graphType: x, showAsGraph: !this.state.showAsGraph },
			() => {
				this.setState({ showAsGraph: !this.state.showAsGraph });
			});
	}

	//#endregion

	//#region Rendus

	// Effectue le rendu du tableau ou du graphique selon la variable d'état showAsGraph
	renderGraphOrTable = () => {
		let table = this.props.table;

		if (this.state.showAsGraph) return <KControlGraph
			GraphSeries={table.GraphSeries}
			GraphSeriesColor={table.GraphSeriesColor}
			colDefs={table.colsDef}
			GraphType={this.state.graphType}
			GraphXPath={table.GraphXPath}
			Rows={table.Rows}
		/>
		else return <KControlTable
			dispatcher={this.props.dispatcher}
			imageProvider={this.props.dispatcher}
			onActionClicked={this.props.onActionClicked}
			table={this.props.table}
			onRowsAdded={this.props.onRowsAdded}
			hideActionBar={this.props.hideActionBar}
		/>
	}

	// Rendu de la liste déroulante des types de graphique
	// Si la liste ne contient qu'un seul élément, elle n'est pas affichée
	renderGraphTypesList = () => {
		if (!this.state.showAsGraph) return "";

		let graphTypes = this.props.table.GraphType.split(";");
		if (graphTypes.length > 1) {
			return (
				<CInputGroup>
					<CInput size="sm" readOnly value={AppLabels[this.state.graphType]} />

					<CInputGroupAppend>
						<CDropdown>
							<CDropdownToggle size="sm" caret color="primary" />
							<CDropdownMenu placement="bottom-end" >
								{
									graphTypes.map((x, i) =>
										<CDropdownItem value={x} key={i} onClick={() => { this.onGraphTypesItemSelected(x); }}>{AppLabels[x]}</CDropdownItem>
									)
								}
							</CDropdownMenu>
						</CDropdown>
					</CInputGroupAppend>
				</CInputGroup>
			);
		}
		return "";
	}

	// Rendu de la barre d'entête qui contient 
	// - La liste déroulant des type de graphique  (si showAsGraph = true)
	// - Le switch permettant de basculer entre la vue tableau & le graphique
	renderHead = () => {
		if (this.props.table.GraphType) {
			let graphTypes = this.renderGraphTypesList();

			return (
				<CFormGroup className="KGraphPresenter head" >
					{graphTypes}
					<CLabel>
						{AppLabels.showAsGraph}
					</CLabel>
					<CSwitch
						size="sm"
						color="success"
						shape={"pill"}
						onChange={() => { this.setState({ showAsGraph: !this.state.showAsGraph }) }}
						value=''
						checked={this.state.showAsGraph}
					>
					</CSwitch>
				</CFormGroup>
			)
		}
		else {
			return "";
		}
	}

	// Rendu principal
	render() {
		let table = this.props.table;

		let sizableAdapter: ISizable = {
			bsSize: table.bsSize,
			Class: table.Class,
			ControlType: ControlTypeEnum.table,
			Description: "",
			MaxLength: 500,
			Value: "",
		}

		let bsSize = Utils.getColSizeClasses(sizableAdapter);

		return (
			<div className={`KControl ${bsSize}`}>
				{this.renderHead()}
				{this.renderGraphOrTable()}
			</div>
		);
	}

	//#endregion
}	